// Zoom normalization helper
// Tracks min/max zoom and provides a 0..1 normalized value

export class ZoomTracker {
  constructor(minZoom = 0.3, maxZoom = 3.0) {
    this._min = minZoom;
    this._max = maxZoom;
    this._last = 1;
  }

  update(zoom) {
    this._last = zoom;
  }

  /** Returns 0..1 where 0 = most zoomed out, 1 = most zoomed in */
  norm() {
    return Math.max(0, Math.min(1, (this._last - this._min) / (this._max - this._min)));
  }

  get zoom() {
    return this._last;
  }
}
